import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import PageContent from '../PageContent';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';
import Segment from 'components/common/Segment';
import SimulationResult from './SimulationResult';
import SimulationResultInfo from './SimulationResultInfo';
import React from 'react';
import SimulationResultConditions from './SimulationResultConditions';
import useSimulationInsulin from 'hooks/communication/useSimulationInsulin';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import useSimulationAgpGraph from 'hooks/communication/useSimulationAgp';
import useSimulationInsulinResult from 'hooks/communication/useSimulationInsulinResult';

export default function SimulationInsulin(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const {
    requestSimulationInsulin,
  } = useSimulationInsulin();

  const [data, setData] = React.useState({});
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    if (!patient_no) return;
    requestSimulationInsulin({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
    }, (success, data) => {
      if (success) {
        setData(() => data);
      } else {
        setData(() => ({}));
      }
    });
  }, [patient_no, period_end, period_start, requestSimulationInsulin]);

  const [additions, setAdditions] = React.useState({ 0: 0, 1: 0, 2: 0, 3: 0 });

  const [agp, setAgp] = React.useState([]);
  const {
    requestSimulationAgpGraph,
  } = useSimulationAgpGraph();

  const {
    requestSimulationInsulinResult,
  } = useSimulationInsulinResult();

  const [result, setResult] = React.useState({ uninitialized: true });
  const onAddition = React.useCallback((index, addition) => () => {
    setAgp(() => []);
    setResult(() => ({ uninitialized: true }));
    setAdditions(as => ({ ...as, [index]: as[index] === addition ? 0 : addition }));
  }, []);

  const insulin_amt_list = React.useMemo(() => {
    const list = [];
    Object.keys(additions).forEach((key, index) => {
      const value = additions[key] || 0;
      list.push({
        time_zone_tp_cd: index + 1,
        insulin_amt: value,
      });
    });
    return list;
  }, [additions]);

  const onExecute = React.useCallback(() => {
    if (!patient_no) return;
    setAgp(() => []);
    setResult(() => ({}));

    requestSimulationAgpGraph({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
      ai_simulation_tp_cd: 'I',
      insulin_amt_list,
    }, (success, data) => {
      if (success) {
        setAgp(() => data?.agp_graph_list || []);
      } else {
        setAgp(() => []);
      }
    });

    requestSimulationInsulinResult({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
      insulin_amt_list,
    }, (success, data) => {
      if (success) {
        setResult(() => data);
      } else {
        setResult(() => ({ uninitialized: true }));
      }
    });
  }, [insulin_amt_list, patient_no, period_end, period_start, requestSimulationAgpGraph, requestSimulationInsulinResult]);

  return (
    <div {...ex('SimulationInsulin', rest)}>
      <PageContent>
        <VBox full>
          <HBox {...ex('Top')}>
            <Segment full>
              <SimulationResultConditions
                {...{
                  data,
                  additions,
                  onAddition,
                  onExecute,
                }}
              />
            </Segment>
            <Segment>
              <SimulationResultInfo />
            </Segment>
          </HBox>
          <Segment>
            <SimulationResult {...{ data, result, agp }} />
          </Segment>
        </VBox>
      </PageContent>
    </div>
  );
}
